const MODULE_NAME = 'fulcrum/container/Project/AERegion'

const UPDATE_AE_REGION = MODULE_NAME + '/UPDATE_AE_REGION'
const UPDATE_AE_REGION_SELECTION = MODULE_NAME + '/UPDATE_AE_REGION_SELECTION'

const FETCH_AE_REGION = MODULE_NAME + '/FETCH_AE_REGION'
const FETCH_AE_REGION_START = MODULE_NAME + '/FETCH_AE_REGION_START'
const FETCH_AE_REGION_SUCCESS = MODULE_NAME + '/FETCH_AE_REGION_SUCCESS'
const FETCH_AE_REGION_ERROR = MODULE_NAME + '/FETCH_AE_REGION_ERROR'

const FETCH_AE_REGION_SELECTION = MODULE_NAME + '/FETCH_AE_REGION_SELECTION'
const FETCH_AE_REGION_SELECTION_START = MODULE_NAME + '/FETCH_AE_REGION_SELECTION_START'
const FETCH_AE_REGION_SELECTION_SUCCESS = MODULE_NAME + '/FETCH_AE_REGION_SELECTION_SUCCESS'
const FETCH_AE_REGION_SELECTION_ERROR = MODULE_NAME + '/FETCH_AE_REGION_SELECTION_ERROR'

const POST_AE_REGION = MODULE_NAME + '/POST_AE_REGION'
const POST_AE_REGION_START = MODULE_NAME + '/POST_AE_REGION_START'
const POST_AE_REGION_SUCCESS = MODULE_NAME + '/POST_AE_REGION_SUCCESS'
const POST_AE_REGION_ERROR = MODULE_NAME + '/POST_AE_REGION_ERROR'

export {
  MODULE_NAME,
  UPDATE_AE_REGION,
  UPDATE_AE_REGION_SELECTION,
  FETCH_AE_REGION,
  FETCH_AE_REGION_START,
  FETCH_AE_REGION_SUCCESS,
  FETCH_AE_REGION_ERROR,
  POST_AE_REGION,
  POST_AE_REGION_START,
  POST_AE_REGION_SUCCESS,
  POST_AE_REGION_ERROR,
  FETCH_AE_REGION_SELECTION,
  FETCH_AE_REGION_SELECTION_START,
  FETCH_AE_REGION_SELECTION_SUCCESS,
  FETCH_AE_REGION_SELECTION_ERROR,
}
